<div
  class="spacer max-width"
  [style.height.px]="data()?.options?.height"></div>
